const routes = {
  login: '/login',
  loginCallback: '/callback',
  newAuthRequest: '/id/auth/new',
  newSignRequest: '/id/sign/new',
  history: '/id/history',
  auth: '/auth',
  sign: '/sign',
  profile: '/profile',
  validateEmail: '/email/validate',
};

export default routes;
